import React, { useEffect, useState } from "react";
import {
  Divider,
  Card,
} from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Link, useParams } from "react-router-dom";
import { baseURL } from "utils/api";
import { ArrowCircleRightOutlined } from "@mui/icons-material";
import Loading from "components/ApnaLoading";
import { useSelector } from "react-redux";

const index = () => {

   const userTheme = useSelector((state) => state.commonSlice.theme);
   const [data, setData] = useState(null);
  const { id } = useParams();
  const adminId = localStorage.getItem('id');
  const [loading, setLoading] = useState(false);


  const fetchData = (ev) => {
    setLoading(true); 
    fetch(`${baseURL}/business-template-details/${ev}/${adminId}`)
      .then(res => res.json())
      .then(data => {
        if (data.status === 200) {
          setLoading(false);
          setData(data?.data)
        }
      }).catch(err => {
        toast.error(err.message || 'Something went wrong');
      });
  };

  useEffect(() => {

    fetchData(id)

  }, [id]);

  console.log(data,'data');


  const formatKey = (key) => {
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
  };

  function formatDate(value) {
    const date = new Date(value);
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Add 1 because months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  return (
    <SoftBox mt={15} sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
    {
      loading?<Loading/>:
   
      <Card className="glassmorphism-card"
        sx={{
          width: "100%",
          maxWidth: 600,
          padding: 6,
          boxShadow: 2,
        }}
      >
        <SoftBox sx={{ display: "flex", alignItems: "center" }} gap={2}>
          <Link to="/offers">

            <ArrowCircleRightOutlined
              style={{ transform: "rotate(180deg)", color:userTheme=='dark'?"#ffffff":"#141414" }}
              fontSize="large"

            />

          </Link>

          <SoftTypography
            variant="h6"
            textAlign="left"
            fontSize={20}
            gutterBottom
          >
            Offer Details
          </SoftTypography>
        </SoftBox>

        <Divider sx={{ mb: 2 }} />

        {data !== null &&
          Object.entries(data).map(([key, value]) => (
            <SoftBox key={key} sx={{ mb: 2, display: "flex", alignItems: 'center', ml: 2 }}>
              <SoftTypography variant="body1" fontWeight="bold">
                {formatKey(key)} :
              </SoftTypography>
              <SoftTypography variant="body2" sx={{ marginLeft: "4px" }}>
                {
                  key === 'startDate' || key === 'endDate'
                    ? formatDate(value)
                    : key === 'category' || key === 'subCategory'
                      ? value?.name
                      :
                      key == 'status'?
                      value === 1 ? 'Active' : 'Inactive'
                      :
                      key === 'locations'
                        ? <SoftBox
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: 1,
                            width: "100%",
                          }}
                        >
                          {
                            value && value.length > 0 && value.map((loc, index) => (
                              <SoftTypography variant="body2" fontWeight="bold" >
                                {loc?.locationName + (index === value.length - 1 ? '' : ', ') || "N/A"}
                              </SoftTypography>
                            ))
                          }
                        </SoftBox>

                        : typeof value === 'object'
                          ? JSON.stringify(value, null, 2)
                          : value}
              </SoftTypography>
            </SoftBox>
          ))}

      </Card>
       }
    </SoftBox>
  );
};

export default index;
